'use strict';

/* exported
externalBookingsCtrl
*/

function externalBookingsCtrl($scope, Restangular, user) {
  $scope.user = user;
  $scope.externalBookings = [];
  $scope.loading = false;
  $scope.pagination = {
    currentPage: 1,
    itemsPerPage: 20,
    totalItems: 0
  };

  function fetchExternalBookings() {
    $scope.loading = true;
    
    var queryParams = {
      offset: ($scope.pagination.currentPage - 1) * $scope.pagination.itemsPerPage,
      limit: $scope.pagination.itemsPerPage
    };

    Restangular.all('booking_notifications').getList(queryParams)
      .then(function(response) {
        if (response.data && Array.isArray(response.data)) {
          $scope.externalBookings = response.data;
          $scope.pagination.totalItems = response.pagination ? response.pagination.total : response.data.length;
        } else {
          $scope.externalBookings = response;
          $scope.pagination.totalItems = response.totalCount || response.length;
        }
        $scope.loading = false;
      })
      .catch(function(error) {
        console.error('Error fetching external bookings:', error);
        $scope.loading = false;
      });
  }

  $scope.onPageChange = function() {
    fetchExternalBookings();
  };

  $scope.formatDepartureTime = function(departureTime) {
    if (!departureTime) return 'N/A';
    return new Date(departureTime).toLocaleString();
  };

  $scope.getIntegrationBookingId = function(rawBookingNotification) {
    return rawBookingNotification && rawBookingNotification.integration_booking_id || 'N/A';
  };

  $scope.getOperatorBookingId = function(rawBookingNotification) {
    return rawBookingNotification && rawBookingNotification.operator_booking_id || 'N/A';
  };

  $scope.getBookingReference = function(rawBookingNotification) {
    return rawBookingNotification && rawBookingNotification.id || 'N/A';
  };

  fetchExternalBookings();
}

'use strict';

/* exported
menuExternalBookingsCtrl
*/

function menuExternalBookingsCtrl($scope, user) {
  $scope.user = user;
  
  // Simple menu for external bookings - can be expanded later with filters
  $scope.refresh = function() {
    // Trigger refresh of external bookings list
    $scope.$broadcast('refreshExternalBookings');
  };
}
